// Global event bus — cross-module communication without direct imports.
//
// Page lifecycle events emitted by core/transitions.js:
//   'page:once'  (data) — initial page load, blocks mounted
//   'page:leave' (data) — current page starts leaving
//   'page:enter' (data) — next page mounted and visible
//
// Block events:
//   'hero:intro' — hero intro finished (or hero had none); blocks/header.js
//                  sequences its own intro after it on media heroes
//
// Usage:
//   import { bus } from '../core/bus';
//   bus.on('page:enter', () => { ... });
//   const off = bus.on('menu:open', handler); off(); // unsubscribe
const events = new Map();

export const bus = {
	on(event, handler) {
		if (!events.has(event)) events.set(event, new Set());
		events.get(event).add(handler);
		return () => this.off(event, handler);
	},

	once(event, handler) {
		const off = this.on(event, (...args) => {
			off();
			handler(...args);
		});
		return off;
	},

	off(event, handler) {
		events.get(event)?.delete(handler);
	},

	emit(event, ...args) {
		events.get(event)?.forEach((handler) => handler(...args));
	},
};
